module.exports = __webpack_public_path__ + "img/کارت-ویزیت-کتان-المان.beaff60b.png";